import React from "react";
import { Card } from "@heroui/react";

export function PageCard({ title, description, children, className = "" }) {
  return (
    <Card
      variant="secondary"
      className={`rounded-2xl border border-white/40 bg-white/35 backdrop-blur-2xl shadow-[0_18px_60px_rgba(0,0,0,0.12)] ${className}`}
    >
      <Card.Header className="rounded-t-2xl border-b border-white/40 bg-white/30 backdrop-blur-xl">
        <Card.Title>{title}</Card.Title>
        {description ? <Card.Description>{description}</Card.Description> : null}
      </Card.Header>
      <Card.Content className="flex flex-col gap-4">{children}</Card.Content>
    </Card>
  );
}
